import React, { useState } from 'react';
import AdSpaceSizeDataTypesAdminList from './components/SizeDataTypesAdminList';
import AdSpaceSizeDataTypesAdminAddSizeDataTypePage from './components/SizeDataTypesAdminAddSizeDataTypePage';
import { Box, Tabs, Tab } from '@mui/material';



const AdSpaceSizeDataTypesAdminPage: React.FC = () => {
  const [tab, setTab] = useState(0);

  const handleTabChange = (_: React.SyntheticEvent, newValue: number) => {
    setTab(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Tabs value={tab} onChange={handleTabChange} aria-label="AdSpaces admin tabs">
        <Tab label="List adSpace MediaTypes" />
        <Tab label="Insert adSpace MediaType" />
      </Tabs>
      <Box sx={{ mt: 2 }}>
        {tab === 0 && <AdSpaceSizeDataTypesAdminList />}
        {tab === 1 && <AdSpaceSizeDataTypesAdminAddSizeDataTypePage />}
      </Box>
    </Box>
  );
};

export default AdSpaceSizeDataTypesAdminPage;